import SysAPI from "IZOX/ARCS/API/SysAPI";
import GState from "./__GState";

import ReqX from "./ReqX";
import GFunc from "./__GFunc";

class Env {

  static async CheckInitialized(){
    let res = await ReqX.SendBE(SysAPI.CheckInitAPI, {}, null, null, (e) => {
      GState.Alert("Cannot connect to server", "error");
      GState.setInitialized(false);
      GFunc.Loading(false);
    });

    let {Success, payload} = res;
    if(Success){
      if(!payload){
        GState.Alert("The project is not initialized. \n Please follow the steps to initialize it.", "info");
        GFunc.Loading(false);
        GState.setInitialized(false);
      }else{
        GFunc.Loading(false);
        GState.setInitialized(true);
      }
    }else{
      GState.setInitialized(false);
      GFunc.Loading(false);
    }
  };

}

export default Env;